export const MANUAL_CATEGORY_ROUTE_PATH = {
  manualCategories: {
    list: { path: "/admin/manual-categories" },
  },
  vpnAccounts: {
    list: { path: "/admin/vpn-accounts" },
  },
};
